import api from './index';

const getShipmentById = (id) => api.get(`/shipment/${id}`);

const postShipment = (data) => api.post('/shipment', data);

const updateShipment = (data) => api.post('/updateShipment', data);

const updatePickupItem = (data) => api.post('/updatePickupItem', data);

const updateLoadItem = (data) => api.post('/updateLoadItem', data);

const updateDeliveringItem = (data) => api.post('/updateDeliveringItem', data);

const updateFlag = (data) => api.post('/updateFlag', data);

export {
  getShipmentById,
  postShipment,
  updateShipment,
  updatePickupItem,
  updateLoadItem,
  updateDeliveringItem,
  updateFlag,
};
